import React from 'react'
import {
  Container,
  ListContainer,
  TextBody,
  TextCaption,
  Image
} from '@pdrj/pmi-iqos-ds-react'
import { Assets, formatDate } from '@pdrj/pmi-iqos-shared-react'

const Value = ({ isWarning, value }) => {
  return isWarning ? (
    <TextBody
      size={TextBody.sizes.m}
      style={TextBody.styles.error}
      data-testing="ProfilePoints_TextCaption_QoinsWarningValue">
      {value}
    </TextBody>
  ) : (
    <TextCaption
      size={TextCaption.sizes.m}
      data-testing="ProfilePoints_TextCaption_QoinsValue">
      {value}
    </TextCaption>
  )
}

const PointsRow = ({
  qoinsData,
  getDate,
  getName,
  getIsWarning,
  getValueLabel,
  getValue,
  invertedValueLayout
}) => {
  const date = getDate && getDate(qoinsData)
  const name = getName && getName(qoinsData)
  const isWarning = getIsWarning && getIsWarning(qoinsData)
  const statusLabel = getValueLabel && getValueLabel(qoinsData)
  const value = getValue && getValue(qoinsData)
  return (
    <Container
      display={Container.displays.flex}
      divider={Container.dividers.bottom}
      dividerColor={Container.dividerColors.default}
      dividerSize={Container.dividerSizes.m}
      pb="4">
      <Container
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.between}>
        <Container
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.between}
          flexDirection={[
            Container.flexDirections.column,
            Container.flexDirections.row,
            Container.flexDirections.row
          ]}
          width="2/3">
          <Container width={['full', '1/2']}>
            {date && (
              <TextBody data-testing="ProfilePoints_TextCaption_QoinsDate">
                {formatDate(date)}
              </TextBody>
            )}
          </Container>
          <Container px={['0', '2']} width={['full', '1/2']}>
            {name && (
              <TextBody
                alignment={[
                  TextBody.alignments.left,
                  TextBody.alignments.center
                ]}
                data-testing="ProfilePoints_TextBody_QoinsName"
                value={name}
                acceptsHtml
              />
            )}
          </Container>
        </Container>
        <Container
          display={Container.displays.flex}
          justifyContent={Container.justifyContentValues.end}
          alignItems={
            invertedValueLayout
              ? Container.alignItemsValues.end
              : Container.alignItemsValues.center
          }
          width="1/3"
          flexDirection={
            invertedValueLayout ? Container.flexDirections.column : null
          }
          flexShrink={0}>
          {invertedValueLayout ? (
            <TextBody data-testing="ProfilePoints_TextBody_QoinsStatus">
              {statusLabel}
            </TextBody>
          ) : (
            <Container pr="1">
              <Image src={Assets.urls.iconPoints} width="4" height="4" />
            </Container>
          )}
          <Value value={value} isWarning={isWarning} />
        </Container>
      </Container>
    </Container>
  )
}

const PointsTable = ({
  qoinsDataList,
  getDate,
  getName,
  getIsWarning,
  getValueLabel,
  getValue,
  invertedValueLayout = false
}) => {
  return qoinsDataList && qoinsDataList.length > 0 ? (
    <ListContainer columns={1} yBetween="4">
      {qoinsDataList.map((qoinsData, qoinsDataIndex) =>
        qoinsData ? (
          <PointsRow
            key={qoinsDataIndex}
            qoinsData={qoinsData}
            getDate={getDate}
            getName={getName}
            getIsWarning={getIsWarning}
            getValueLabel={getValueLabel}
            getValue={getValue}
            invertedValueLayout={invertedValueLayout}
          />
        ) : null
      )}
    </ListContainer>
  ) : null
}

export default PointsTable
